module.exports = __webpack_public_path__ + "static/blog67-de05d7676d00345787adb52ca4f13f5f.png";